import { render } from "./ClientAddEditFormModal.vue?vue&type=template&id=7d6c3f22&lang=pug"
import script from "./ClientAddEditFormModal.vue?vue&type=script&lang=ts"
export * from "./ClientAddEditFormModal.vue?vue&type=script&lang=ts"

import "./ClientAddEditFormModal.vue?vue&type=style&index=0&id=7d6c3f22&lang=scss"
script.render = render

export default script